export const MOBILE_MEDIA_QUERY = "(min-width:900px)";
